/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Plugin } from 'ckeditor5';

export class UsersIntegration extends Plugin {
	static get requires() {
		return [ 'Users' ];
	}

	static get pluginName() {
		return 'UsersIntegration';
	}

	init() {
		const usersPlugin = this.editor.plugins.get( 'Users' );

		// These are sample users for demonstration purposes.
		// In your integration make sure to provide user data from your data source.
		const users = [
			{ id: 'user-1', name: 'Zee Croce' },
			{ id: 'user-2', name: 'Mex Haddox' }
		];
		const me = users[ 0 ];

		for ( const user of users ) {
			usersPlugin.addUser( user );
		}

		usersPlugin.defineMe( me.id );
	}
}
